const EXTERNAL_LINKS = [
  {
    displayName: "Pathways to uni",
    url:
      "https://www.uac.edu.au/future-applicants/admission-criteria/pathways-to-university"
  },
  {
    displayName: "Uni access schemes",
    url:
      "https://www.uac.edu.au/future-applicants/scholarships-and-schemes/educational-access-schemes"
  },
  {
    displayName: "Scholarships",
    url:
      "https://www.uac.edu.au/future-applicants/scholarships-and-schemes/equity-scholarships"
  }
];
export default EXTERNAL_LINKS;
